"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_ENDPOINT_ERROR = exports.CREATE_ENDPOINT_ERROR = void 0;
var CREATE_ENDPOINT_ERROR = 'CREATE_ENDPOINT_ERROR';
exports.CREATE_ENDPOINT_ERROR = CREATE_ENDPOINT_ERROR;
var UPDATE_ENDPOINT_ERROR = 'UPDATE_ENDPOINT_ERROR';
exports.UPDATE_ENDPOINT_ERROR = UPDATE_ENDPOINT_ERROR;